import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolFontSize from '../../../../types/font-size'
import SelectListComponent from '../../../select-list'
import { CreationSourceEditorContext } from '../../manager'

const SelectList = styled(SelectListComponent)`
    width: 100%;
`

const CreationSourceEditorCaptionSizeDropwdown = () => {
    const { captionStyle, setCaptionStyle } = useContext(CreationSourceEditorContext)
    const { fontSize: currentFontSize } = captionStyle
    const allSizes = CreationToolFontSize.all()

    const onChange = (fontSize: CreationToolFontSize) => {
        setCaptionStyle({
            ...captionStyle,
            fontSize,
        })
    }

    return (
        <SelectList
            {...{
                onChange,
                value: currentFontSize,
                options: allSizes.map(fontSize => ({
                    value: fontSize,
                    label: CreationToolFontSize.title(fontSize),
                })),
            }}
        />
    )
}

export default CreationSourceEditorCaptionSizeDropwdown
